import { render } from "./CustomSeparator.vue?vue&type=template&id=66ac409a&scoped=true"
import script from "./CustomSeparator.vue?vue&type=script&lang=js"
export * from "./CustomSeparator.vue?vue&type=script&lang=js"

import "./CustomSeparator.vue?vue&type=style&index=0&id=66ac409a&scoped=true&lang=css"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ac409a"]])

export default __exports__